import StatisticParameters from '@/components/StatisticParameters/StatisticParameters';

export default StatisticParameters;
